var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { QuestionPassStateId, TrackIdent } from '../../../learnware/LearnwareEnums';
export class AnswerSkip {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get answer() {
        return this.parent;
    }
    get app() {
        return this.answer.app;
    }
    get question() {
        return this.answer.question;
    }
    skipQuestion() {
        this.question.mini.miniPassState.setQuestionState(QuestionPassStateId.Skipped);
        this.answer.wasSkipped = true;
        this.app.funnel.recalculateFunnel();
        this.app.directive.directivePoseQuestion.removeCurrentQuestionAndRePose();
        this.app.track.trackEvent({
            ident: TrackIdent.SkipQuestion,
            question_id: this.question.id,
            answer_id: this.answer.id,
        });
    }
    blockQuestion() {
        this.question.mini.miniPassState.setQuestionState(QuestionPassStateId.Blocked);
        this.app.funnel.recalculateFunnel();
        this.app.directive.directivePoseQuestion.removeCurrentQuestionAndRePose();
        this.app.track.trackEvent({
            ident: TrackIdent.BlockQuestion,
            question_id: this.question.id,
            answer_id: this.answer.id,
        });
        /* window.gtag('event', 'Skip', {
           event_category: 'Question',
           event_label: this.question.id_string,
           value: 1,
         }); */
    }
}
__decorate([
    action.bound
], AnswerSkip.prototype, "skipQuestion", null);
__decorate([
    action.bound
], AnswerSkip.prototype, "blockQuestion", null);
